import React from 'react';
import {
  ImageWidget,
  VideoUrlWidget,
  FileWidget,
} from './widgets';
import {
  ReferralField,
} from './fields';
import SortableField from './SortableField';
import schemas from './schemas/admin';

const graphqlUrl = process.env.REACT_APP_GRAPHQL_URL;

const resources = Object.keys(schemas).map(key => schemas[key]);

// NOTE: columnNames is a computed property
const AdminGqlCmsConfig = {
  brand: 'EncourageX CMS',
  title: 'EncourageX CMS',
  mainTitle: 'EncourageX CMS - Admin Dashboard View',
  samplesTitle: 'Curator Samples',
  graphqlUrl,
  jsonSchemaFormExtensions: {
    widgets: {
      imageWidget: ImageWidget,
      videoUrlWidget: VideoUrlWidget,
      fileWidget: FileWidget,
    },
    fields: {
      sortableField: SortableField,
      referralField: ReferralField,
    },
  },
  readManySchema: {
    cellFormatter(value) {
      if (value && typeof value === 'object') {
        return <pre>{JSON.stringify(value)}</pre>;
      }
      return value;
    },
    sortStrategy: {
      type: 'SINGLE',
      defaultSortField: 'title',
    },
    searchStrategy: {
      type: 'FULLTEXT',
    },
    paginationStrategy: {
      type: 'STATIC',
    },
  },
  resources,
};

export default AdminGqlCmsConfig;



// WEBPACK FOOTER //
// ./src/AdminGqlCmsConfig.js